import { render, staticRenderFns } from "./price_dimension.vue?vue&type=template&id=126e0e8a&scoped=true"
import script from "./price_dimension.vue?vue&type=script&lang=js"
export * from "./price_dimension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126e0e8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('126e0e8a')) {
      api.createRecord('126e0e8a', component.options)
    } else {
      api.reload('126e0e8a', component.options)
    }
    module.hot.accept("./price_dimension.vue?vue&type=template&id=126e0e8a&scoped=true", function () {
      api.rerender('126e0e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/price_maintain/form/components/price_dimension.vue"
export default component.exports